import { useState } from 'react';
import friends from '../../../assets/friends.svg';
import transfer from '../../../assets/transfer.svg';
import settings from '../../../assets/settings.svg';
import SendModalContainer from './SendModalContainer';
import SettingsModal from '../profile-settings/components/SettingsModal';
import { useNavigate } from 'react-router-dom';
import ROUTES from '@/routers/Routes';

const ControlItem = ({
  src,
  alt,
  label,
  onClick,
}: {
  src: string;
  alt: string;
  label: string;
  onClick?: () => void;
}) => {
  return (
    <div
      className="flex cursor-pointer flex-col items-center text-ph-gray-dark transition duration-300 hover:text-ph-gray-white hover:drop-shadow-[0_0_3px_rgba(255,255,255,1)]"
      onClick={onClick}
    >
      <img src={src} alt={alt} width={20} height={20} className="transition duration-300" />
      <p className="text-xs">{label}</p>
    </div>
  );
};

const UserControls = () => {
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const navigate = useNavigate();

  return (
    <>
      <div className="flex w-full justify-between px-10 pt-5">
        <ControlItem src={friends} alt="Friends" label="Friends" onClick={() => navigate(ROUTES.FRIENDS)} />
        <ControlItem
          src={transfer}
          alt="Transfer"
          label="Send"
          onClick={() => {
            setShowTransferModal(true);
          }}
        />
        <ControlItem
          src={settings}
          alt="Settings"
          label="Settings"
          onClick={() => {
            setIsSettingsOpen(true);
          }}
        />
      </div>
      <SendModalContainer
        open={showTransferModal}
        setClose={() => {
          setShowTransferModal(false);
        }}
      />
      {isSettingsOpen && (
        <div className="relative inline-block text-left">
          <SettingsModal
            isOpen={isSettingsOpen}
            onClose={() => {
              setIsSettingsOpen(false);
            }}
          />
        </div>
      )}
    </>
  );
};

export default UserControls;
